import axios from "axios"

export const ModdApi = axios.create({
  baseURL: process.env.MODD_CART_API,
  headers: {Accept: "application/json"},
  withCredentials: true,
})